import { AuditEntry } from '../types';
import Icon from '../../../components/AppIcon';

interface AuditTrailPanelProps {
  auditTrail: AuditEntry[];
}

const AuditTrailPanel = ({ auditTrail }: AuditTrailPanelProps) => {
  const getActionIcon = (action: string) => {
    if (action.includes('criou') || action.includes('criada')) return 'Plus';
    if (action.includes('visualizou') || action.includes('acessou')) return 'Eye';
    if (action.includes('exportou')) return 'Download';
    if (action.includes('re-executou')) return 'RefreshCw';
    if (action.includes('anotação')) return 'MessageSquare';
    return 'Activity';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground">Trilha de Auditoria</h2>
        <span className="text-sm text-muted-foreground">
          {auditTrail.length} {auditTrail.length === 1 ? 'evento' : 'eventos'}
        </span>
      </div>

      <div className="space-y-4">
        {auditTrail.map((entry, index) => (
          <div key={entry.id} className="relative">
            {index !== auditTrail.length - 1 && (
              <div className="absolute left-4 top-10 bottom-0 w-px bg-border" />
            )}
            
            <div className="flex gap-4">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center relative z-10">
                <Icon 
                  name={getActionIcon(entry.action)} 
                  size={16} 
                  color="var(--color-primary)" 
                />
              </div>

              <div className="flex-1 pb-6">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <p className="text-sm font-medium text-foreground">{entry.action}</p>
                    <p className="text-xs text-muted-foreground mt-1">{entry.details}</p>
                  </div>
                  <span className="text-xs text-muted-foreground whitespace-nowrap ml-4">
                    {entry.timestamp.toLocaleString('pt-BR')}
                  </span>
                </div>

                <div className="flex items-center gap-4 text-xs text-muted-foreground mt-2">
                  <div className="flex items-center gap-1">
                    <Icon name="User" size={12} color="currentColor" />
                    <span>{entry.user}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Globe" size={12} color="currentColor" />
                    <span className="font-mono">{entry.ipAddress}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuditTrailPanel;